module.exports = __webpack_public_path__ + "img/logoDiagram.878cc564.png";